import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { Formik } from "formik";
import * as Yup from "yup";

import clsx from "clsx";
import { withStyles } from "@material-ui/core/styles";

import {
	Grid, Paper, TextField, InputAdornment
} from "@material-ui/core";
import PayrollStyle from "./payrollStyle";

import * as parameterTypes from "../../constants/parameterTypes";

import { DialogCommonComponent, NumberFormatCustomComponent } from "../common";
import { payrollQuantitiesDefaultData } from "../../reducers/Payroll/PayrollInitialState";
import payrollQuantityList from "../../helpers/payrollQuantityList.json"

class ModalQuantity extends Component {
	validationSchema = Yup.object({
		name: Yup.string()
			.required("Selected Quantity")
			.test("name-default", "Selected Quantity", value => value !== "-"),
		rate: Yup.number().required("Rate is required"),
		quantity: Yup.number().required("Quantity is required"),
		totalAmount: Yup.number().required("Total is required")
	});

	renderQuantityOptions = () => {
		// const { payrollQuantityList, classes } = this.props;
		const { classes } = this.props;
		const values = [
			<option key="option_0" value="-" className={classes.option}>
				Select option
			</option>
		];
		values.push(
			payrollQuantityList
				.sort((firstEl, secondEl) => firstEl.order < secondEl.order)
				.map(item => (
					<option key={`${item.id}`} value={`${item.value}`} className={classes.option}>
						{item.value}
					</option>
				))
		);

		return values;
	};

	handleSubmitQuantity = (value, actions) => {
		const { onAddValues } = this.props;
		actions.setSubmitting(false);
		onAddValues(value);
	};

	handleChangeValues = (name, event, formProps, nameTotal) => {
		const { value } = event.target;

		formProps.setFieldValue(name, value);

		const total = parseFloat(value * (name === "rate" ? formProps.values.quantity : formProps.values.rate)).toFixed(2);
		formProps.setFieldValue(nameTotal, isNaN(total) ? 0 : total);
	};

	renderForm = (formProps) => {
		const {
			classes, open, onCloseModal, edit
		} = this.props;

		return (
			<DialogCommonComponent title="Payments per Job / Unit" primaryButtonName={edit ? "Update" : "Save"} size="xs" onPrimaryButtonClick={formProps.handleSubmit} open={open} onCloseModal={onCloseModal}>
				<Grid container direction="row" alignItems="center">
					<Grid item xs={12}>
						<Paper className={classes.paperGrid}>
							<TextField
								id="name"
								label="Per Job / Unit *"
								select
								variant="filled"
								fullWidth
								disabled={edit}
								value={formProps.values.name}
								onChange={formProps.handleChange}
								onBlur={formProps.handleBlur}
								className={clsx(classes.textField, {
									error: formProps.errors.name && formProps.touched.name
								})}
								SelectProps={{
									native: true,
									MenuProps: {
										className: classes.menu
									}
								}}
							>
								{this.renderQuantityOptions()}
							</TextField>
						</Paper>
					</Grid>

					<Grid item xs={12}>
						<Paper className={classes.paperGrid}>
							<TextField
								id="description"
								label="Description"
								variant="filled"
								fullWidth
								value={formProps.values.description}
								onChange={(value) => {
									this.handleChangeValues("description", value, formProps);
								}}
								onBlur={formProps.handleBlur}
								className={clsx(classes.textField, {
									error: formProps.errors.description && formProps.touched.description
								})}
							/>
						</Paper>
					</Grid>

					<Grid item xs={6}>
						<Paper className={classes.paperGrid}>
							<TextField
								id="rate"
								label="Rate *"
								InputProps={{
									startAdornment: <InputAdornment position="start">$</InputAdornment>,
									inputComponent: NumberFormatCustomComponent,
									inputProps: {
										decimalScale: 4
									}
								}}
								variant="filled"
								fullWidth
								value={formProps.values.rate}
								onChange={(value) => {
									this.handleChangeValues("rate", value, formProps, "totalAmount");
								}}
								onBlur={formProps.handleBlur}
								className={clsx(classes.textField, {
									error: formProps.errors.rate && formProps.touched.rate
								})}
							/>
						</Paper>
					</Grid>
					<Grid item xs={6}>
						<Paper className={classes.paperGrid}>
							<TextField
								id="quantity"
								label="Quantity *"
								variant="filled"
								fullWidth
								InputProps={{
									inputComponent: NumberFormatCustomComponent,
									inputProps: {
										decimalScale: 2
									}
								}}
								value={formProps.values.quantity}
								onChange={(value) => {
									this.handleChangeValues("quantity", value, formProps, "totalAmount");
								}}
								onBlur={formProps.handleBlur}
								className={clsx(classes.textField, {
									error: formProps.errors.quantity && formProps.touched.quantity
								})}
							/>
						</Paper>
					</Grid>
					<Grid item xs={12}>
						<Paper className={classes.paperGrid}>
							<TextField
								id="totalAmount"
								label="Total *"
								fullWidth
								InputProps={{
									startAdornment: <InputAdornment position="start">$</InputAdornment>,
									readOnly: true,
									inputComponent: NumberFormatCustomComponent,
									inputProps: {
										decimalScale: 4
									}
								}}
								value={formProps.values.totalAmount}
								onChange={formProps.handleChange}
								onBlur={formProps.handleBlur}
								className={clsx("onlyReadTitle", {
									error: formProps.errors.totalAmount && formProps.touched.totalAmount
								})}
							/>
						</Paper>
					</Grid>
				</Grid>
			</DialogCommonComponent>
		);
	};

	render() {
		const { data } = this.props;

		const dataDefault = {
			...payrollQuantitiesDefaultData,
			...data
		};

		return <Formik initialValues={{ ...dataDefault }} validationSchema={this.validationSchema} onSubmit={this.handleSubmitQuantity} render={this.renderForm} enableReinitialize />;
	}
}

ModalQuantity.propTypes = {
	payrollQuantityList: PropTypes.array,
	onAddValues: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
	payrollQuantityList: state.parameters.parameterByTypeData[parameterTypes.PARAMETER_QUANTITY_PAYROLL.parameterType]
});

export default connect(
	mapStateToProps,
	null
)(withStyles(PayrollStyle)(ModalQuantity));
